import React, { useEffect, useState } from "react";
import axios from "axios";

const FundRequestPage = () => {
  const [requests, setRequests] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);


  const fetchRequests = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API}/wallet/pending-fund-requests`);
    setRequests(res.data);
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const approveRequest = async (id) => {
    if (!window.confirm("Approve this fund request?")) return;
    await axios.put(`${process.env.REACT_APP_API}/wallet/approve-fund/${id}`);
    fetchRequests();
  };

  const rejectRequest = async (id) => {
    if (!window.confirm("Reject this fund request?")) return;
    await axios.put(`${process.env.REACT_APP_API}/wallet/reject-fund/${id}`);
    fetchRequests();
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-4">Pending Fund Requests</h4>

      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>Name</th>
            <th>Amount</th>
            <th>Order ID</th>
            <th>Screenshot</th>
            <th>Message</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {requests.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No pending requests
              </td>
            </tr>
          ) : (
            requests.map((req) => (
              <tr key={req.id}>
                <td>{req.name}</td>
                <td>₹ {req.amount}</td>
                <td>{req.order_id}</td>
                <td>
  <img
    src={`${process.env.REACT_APP_API}/uploads/${req.screenshot}`}
    alt="Payment Screenshot"
    width="100"
    style={{ cursor: "pointer", border: "1px solid #ccc", padding: "4px" }}
    onClick={() =>
      setPreviewImage(
        `${process.env.REACT_APP_API}/uploads/${req.screenshot}`
      )
    }
  />
</td>

                <td>{req.user_message}</td>
                <td>
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => approveRequest(req.id)}
                  >
                    Accept
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => rejectRequest(req.id)}
                  >
                    Reject
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {previewImage && (
  <div
    className="modal fade show"
    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)",maxWidth: '90%', maxHeight: '90%', borderRadius: '8px' }}
    onClick={() => setPreviewImage(null)}
  >
    <div className="modal-dialog modal-dialog-centered modal-lg">
      <div className="modal-content">
        <div className="modal-body text-center">
          <img
            src={previewImage}
            alt="Preview"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default FundRequestPage;
